/* eslint-disable react-hooks/exhaustive-deps */
import { logo } from 'assets/index'
import { isAuthorized } from 'ducks/selectors'
import { useSelector } from 'react-redux'
import { Box } from '../../../../UI'
import UtmParamsWrapper from '../../../Auth/UtmParamsWrapper'
import Work from './Work'
import useStyles from './styles'

const Account = () => {
  const classes = useStyles()
  const authorized = useSelector(isAuthorized)

  return (<>
    <Box className={classes.root} aria-label="estimate-account">
      <Box className={classes.content}>
        {!authorized && <img src={logo} alt="" style={{ width: '225px' }} />}
        {/* 
        {showRegister ? (
          <Register />
        ) : ( */}
        <UtmParamsWrapper>
          <Work /* setShowRegister={setShowRegister} */ />
        </UtmParamsWrapper>
        {/*   )} */}
      </Box>
    </Box>
  </>
  )
}

export default Account
